import aftershock from './Aftershock_rune.png'
import conditioning from './Conditioning_rune.png'
import demolish from './Demolish_rune.png'
import fontOfLife from './Font_of_Life_rune.png'
import graspOfTheUndying from './Grasp_of_the_Undying_rune.png'
import guardian from './Guardian_rune.png'
import overgrowth from './Overgrowth_rune.png'
import resolveIcon from './Resolve_icon.png'
import revitalize from './Revitalize_rune.png'
import secondWind from './Second_Wind_rune.png'
import sheildBash from './Shield_Bash_rune.png'
import unflinching from './Unflinching_rune.png'
import bonePlating from './Bone_Plating_rune.png'

const resolveRunesList = {
  aftershock: aftershock,
  conditioning: conditioning,
  demolish: demolish,
  fontOfLife: fontOfLife,
  graspOfTheUndying: graspOfTheUndying,
  guardian: guardian,
  overgrowth: overgrowth,
  resolveIcon: resolveIcon,
  revitalize: revitalize,
  secondWind: secondWind,
  sheildBash: sheildBash,
  unflinching: unflinching,
  bonePlating: bonePlating,
}

export default resolveRunesList
